module.exports = __webpack_public_path__ + "media/images/elasticity-94a41915a7b16d1fdcafe6b6856d754b.svg";